import React from "react";
var __jsx = React.createElement;
import BlogArticleListComp from './BlogArticleList';
function BlogArticleListAdapter(_ref) {
  var entry = _ref.entry,
    data = _ref.data;
  var categories = entry.itemsCollection.items.reduce(function (aggr, record) {
    var category = record.blogCategory.categoryName;
    if (!aggr.includes(category)) {
      aggr.push(category);
    }
    return aggr;
  }, []);
  var anchorLink = (entry === null || entry === void 0 ? void 0 : entry.anchorLink) || '';
  return __jsx(BlogArticleListComp, {
    blogArticleListData: entry.itemsCollection.items,
    currentPage: "{currentPage}",
    slugifiedTitle: "{title}",
    categoryValues: categories,
    selectedValue: "",
    categoryFilter: categories,
    pageUrl: data.DynamicLayoutPage.url || '/blog',
    anchorLink: anchorLink
  });
}
export default BlogArticleListAdapter;